import { useState } from 'react'

import { performRentalPortalApplicantTransition } from '../../../../../../../api'
import { useUserData } from '../../../../../../../hooks'
import {
  getIsMockApplicantId,
  postMockApplicantDecision,
} from '../../../../../../RentalPortalApplicant'
import {
  ApplicantDecisionModal,
  getIsApplicantBlockConflictError,
} from '../../../..'
import { APPLICANT_DECISION_TRANSITION_ACTION } from '../../ApplicantDecisionPanel.constants'
import { getApplicantDecisionConflictKey } from '../../ApplicantDecisionPanel.utils'

export function useApplicantDecisionActions({
  applicantData,
  applicantId,
  handleCloseModal,
  handleEntityReload,
  setModal,
}) {
  const currentUser = useUserData()

  const [conflictKey, setConflictKey] = useState(null)

  async function submitDecision({ action, note }) {
    setConflictKey(null)

    try {
      await (getIsMockApplicantId(applicantId)
        ? postMockApplicantDecision({
            action,
            applicantId,
            currentUser,
            note,
          })
        : performRentalPortalApplicantTransition({
            action: APPLICANT_DECISION_TRANSITION_ACTION[action],
            data: { note },
            id: applicantId,
          }))
    } catch (error) {
      if (!getIsApplicantBlockConflictError(error)) {
        throw error
      }

      setConflictKey(getApplicantDecisionConflictKey(error))
    }

    handleCloseModal()

    await handleEntityReload()
  }

  function handleClickAction(action) {
    setConflictKey(null)

    setModal(
      <ApplicantDecisionModal
        action={action}
        applicantData={applicantData}
        onClose={handleCloseModal}
        onSubmit={note => submitDecision({ action, note })}
      />
    )
  }

  return { conflictKey, handleClickAction }
}
